import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=08ecc513&scoped=true"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecc513",
  null
  
)

export default component.exports